import React from 'react';

const Newsletter = () => {
  return (
    <section className="newsletter">
      <div className="container">
        <div className="newsletter-content">
          <h2>Stay Connected</h2>
          <p>Check daily for new arrivals and requests</p>
        </div>
      </div>
    </section>
  );
};

export default Newsletter; 